<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12" v-if="newsList">
        <v-data-table :headers="headers" :items="newsList" sort-by="postedDateTime desc" class="elevation-1"
          hide-default-footer disable-pagination calculate-widths mobile-breakpoint="0" dense :search="search">

          <template v-slot:top>
            <v-toolbar flat>
              <v-text-field v-model="search" append-icon="mdi-magnify" label="Search" single-line hide-details>
              </v-text-field>
              <v-btn class="ma-2" outlined to="/news/new">
                New
                <i aria-hidden="true" class="v-icon notranslate mdi mdi-newspaper theme--light"
                  style="font-size: 16px"></i>
              </v-btn>

              <v-spacer></v-spacer>


              <v-dialog v-model="dialogDelete" v-if="selectedItem" max-width="500px">
                <v-card>
                  <v-card-title class="text-h5 no-word-wrap">Are you sure you want to delete the article entitled "{{ selectedItem.title }}" ?</v-card-title>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="blue darken-1" text @click="closeDelete">Cancel</v-btn>
                    <v-btn color="blue darken-1" text @click="deleteItemConfirm">OK</v-btn>
                    <v-spacer></v-spacer>
                  </v-card-actions>
                </v-card>
              </v-dialog>
            </v-toolbar>
          </template>

          <template v-slot:item.actions="{ item }">
            <v-icon small class="mr-2" @click="editItem(item)"> mdi-pencil </v-icon>
            <v-icon small @click="deleteItem(item)"> mdi-delete </v-icon>
          </template>

          <template v-slot:item.postedDateTime="{ item }">
            <span style="white-space: nowrap">
              {{ formatPalmDateTime(item.postedDateTime) }}</span>
          </template>


          <template v-slot:no-data>
            <v-btn color="primary" @click="getNews()"> Reset </v-btn>
          </template>

        </v-data-table>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import serverFunctions from "@/functions/serverFunctions";
import userFunctions from "@/functions/userFunctions";
import dateFunctions from "@/functions/dateFunctions";

export default {
  data: () => ({
    selectedItem: null,
    dialogDelete: false,
    newsList: null,
    search: null,
    headers: [
      { text: "Actions", value: "actions", sortable: false },
      {
        text: "News Title",
        align: "start",
        value: "title",
      },
      {
        text: "Date Posted",
        align: "start",
        value: "postedDateTime",
      },
    ],
  }),
  methods: {
    formatPalmDateTime(datetime) {
      return dateFunctions.formatPalmDateTime(datetime);
    },
    async getNews() {
      this.newsList = await serverFunctions.getResponse("/getAllNews");
    },
    editItem(item) {
      let path = "/news/edit/" + item.id;
      this.$router.push(path)
    },
    deleteItem(item) {
      this.selectedItem = item;
      this.dialogDelete = true;
    },
    deleteItemConfirm() {
      this.processDelete(this.selectedItem.id);
      this.closeDelete();
    },
    async processDelete(newsId) {
      
      if(!newsId || newsId < 0) {
        return;
      }

      const deleteNewsRequest = serverFunctions.getDataRequestObject(
        userFunctions.getLoggedInUser(),
        newsId
      );

      await serverFunctions.getPostResponse("/deleteNews", deleteNewsRequest);

      this.getNews();
    
    }, close() {
      this.dialog = false;
      this.$nextTick(() => {
        this.selectedItem = null;
      });
    },
    closeDelete() {
      this.dialogDelete = false;
      this.$nextTick(() => {
        this.selectedItem = null;
      });
    },
  },
  beforeMount() {
    this.getNews();
  }
};
</script>

<style scoped>
.white-text {
  color: white;
}
</style>
